export enum AolPageEnum {
    Reporting = 0,
    Approval = 1,
    Approved = 2,
}
